import Row from '@/components/LayoutTools/Sidebar/items/SharedFeatures/Row';
import Link from 'next/link';
import { useRouter } from 'next/router';
import React from 'react';

export default function SingleItem({
  icon,
  label,
  url,
  sidebarWidth,
  toggleResize,
  level = 0,
  isChild = false,
  lastChild = false,
}) {
  const router = useRouter();
  const active = router.asPath === url;

  function handleClick(e) {
    if (sidebarWidth < 80) {
      e.preventDefault();
      toggleResize();
    }
  }

  return (
    <Link onClick={handleClick} href={url} style={{ textDecoration: 'none' }}>
      <Row
        icon={icon}
        label={label}
        isChild={isChild}
        lastChild={lastChild}
        active={active}
        level={level}
      />
    </Link>
  );
}
